import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { createAuthToolsMiddlewares } from '@nerdwallet/js-auth-tools/middleware';

import rootReducer from './reducers';
import nwApiSDK, { identityProfilesToInclude } from './nw-api-sdk';

const authToolsMiddlewares = createAuthToolsMiddlewares({
  asyncOptions: {
    IdentitySDK: nwApiSDK.IdentitySDK,
    identityProfilesToInclude,
    identityApp: nwApiSDK.IdentitySDK.APPS.NERDWALLET_WEB,
  },
});

const config = (initialState) => {
  const middlewares = [...authToolsMiddlewares, thunkMiddleware];
  const devInClient =
    process.env.NODE_ENV === 'development' && process.env.IN_BROWSER === true;

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middlewares),
    devInClient && window.devToolsExtension
      ? window.devToolsExtension()
      : (f) => f
  )(createStore);

  const store = createStoreWithMiddleware(rootReducer, initialState);

  store.additionalReducers = {};

  return store;
};

export default config;
